import { ListingDetailsResolver } from './resolvers/listing-details.resolver';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ListingComponent } from './containers/listing/listing.component';
import { DetailsComponent } from './containers/details/details.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { RentComponent } from './containers/rent/rent.component';
import { RentFormComponent } from './components/rent-form/rent-form.component';
import { RentPaymentComponent } from './components/rent-payment/rent-payment.component';
import { ListingDetailsComponent } from './containers/listing-details/listing-details.component';
import { ResultsComponent } from './containers/results/results.component';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatInputModule } from '@angular/material/input';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatCardModule } from '@angular/material/card';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatChipsModule } from '@angular/material/chips';
import { NpnSliderModule } from 'npn-slider';
import { ScrollableDirective } from '@app/shared/directives/scrollable.directive';
import { SharedModule } from '@app/shared/shared.module';
import { ResultResolver } from './resolvers/result.resolver';
import { TaskResolver } from './resolvers/listing.resolver';
import { RouterModule } from '@angular/router';
import { listingRoutes } from './listing.routes';
import { StickyFormComponent } from './components/sticky-form/sticky-form.component';
import { MapResultComponent } from './components/map-result/map-result.component';
import { ListingReviewsComponent } from './containers/listing-details/listing-reviews/listing-reviews.component';
import { SwiperModule } from 'swiper/angular';
import { MatButtonModule } from '@angular/material/button';
import { ListingItemComponent } from './components/listing-item/listing-item.component';
import { NotifierModule, NotifierOptions } from 'angular-notifier';

const customNotifierOptions: NotifierOptions = {
  position: {
    horizontal: {
      position: 'middle',
      distance: 12
    },
    vertical: {
      position: 'top',
      distance: 100,
      gap: 10
    }
  },
  theme: 'material',
  behaviour: {
    autoHide: 5000,
    onClick: 'hide',
    onMouseover: 'pauseAutoHide',
    showDismissButton: true,
    stacking: 4
  },
  animations: {
    enabled: true,
    show: {
      preset: 'slide',
      speed: 1000,
      easing: 'ease'
    },
    hide: {
      preset: 'fade',
      speed: 300,
      easing: 'ease',
      offset: 50
    },
    shift: {
      speed: 300,
      easing: 'ease'
    },
    overlap: 150
  }
};

@NgModule({
  declarations: [
    ListingComponent,
    DetailsComponent,
    RentComponent,
    RentFormComponent,
    RentPaymentComponent,
    ListingDetailsComponent,
    ResultsComponent,
    StickyFormComponent,

    ScrollableDirective,

    MapResultComponent,

    ListingReviewsComponent,

    ListingItemComponent
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(listingRoutes),
    SharedModule,
    NgbModule,
    FormsModule,
    ReactiveFormsModule,
    MatSlideToggleModule,
    MatPaginatorModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatBottomSheetModule,
    MatSelectModule,
    MatCheckboxModule,
    MatInputModule,
    MatCardModule,
    MatChipsModule,
    MatFormFieldModule,
    MatProgressBarModule,
    NpnSliderModule,
    SwiperModule,
    NotifierModule.withConfig(customNotifierOptions),
  ],
  entryComponents: [RentPaymentComponent],
  providers: [TaskResolver, ResultResolver, ListingDetailsResolver]
})
export class ListingModule { }
